export default __webpack_public_path__ + "static/media/linkedin-logo.7cc49b82.svg";